import {useMemo} from 'react';
import type {StockMatrix} from '@ozon-ai/ozon/contracts';
import {Card, CardContent} from '@/components/ui/card.tsx';
import {DataTable} from '@/components/ui/data-table.tsx';
import {cn} from 'cn';
import {
	createStockMatrixColumns,
	mapStockMatrixRows,
} from './stock-matrix-columns';

const stickyProductHeadClass =
	'sticky left-0 z-10 min-w-[180px] max-w-[280px] bg-muted/40 shadow-[1px_0_0_0_var(--border)]';
const stickyProductCellClass =
	'sticky left-0 z-10 min-w-[180px] max-w-[280px] bg-card shadow-[1px_0_0_0_var(--border)]';

type StockMatrixDataTableProps = {
	matrix: StockMatrix;
	nameByOfferId: Map<string, string>;
};

export function StockMatrixDataTable({matrix, nameByOfferId}: StockMatrixDataTableProps) {
	const columns = useMemo(
		() => createStockMatrixColumns(matrix.days),
		[matrix.days],
	);
	const data = useMemo(
		() => mapStockMatrixRows(matrix.rows, nameByOfferId),
		[matrix.rows, nameByOfferId],
	);

	return (
		<Card className="gap-0 overflow-hidden py-0 shadow-sm">
			<CardContent className="p-0">
				<DataTable
					columns={columns}
					data={data}
					className="rounded-none border-0"
					headerClassName={(columnId) =>
						cn(
							columnId === 'productName'
								? stickyProductHeadClass
								: 'text-right text-muted-foreground tabular-nums',
						)
					}
					cellClassName={(columnId) =>
						cn(
							columnId === 'productName'
								? stickyProductCellClass
								: 'text-right tabular-nums',
						)
					}
				/>
			</CardContent>
		</Card>
	);
}
